export const Divider = () => (
  <div className="tw-w-full tw-flex tw-items-center">
    <div className="tw-flex tw-flex-grow h-1 bg-gray-main"></div>
    <span className="tw-font-body4 tw-mx-3.2">{'O'}</span>
    <div className="tw-flex tw-flex-grow h-1 bg-gray-main"></div>
  </div>
);
